import React from "react";
import {Navigate} from "react-router-dom";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import Dashboard from "./Dashboard";

const LegacyDashboardRoute = () => {
    const {authUser} = useJumboAuth();

    if (!authUser) return null;

    if (authUser.current_company?.id !== 80) {
        return <Navigate to="/business-dashboard" replace/>;
    }

    return <Dashboard/>;
};

export default LegacyDashboardRoute;
